import React from "react";
import { Col, ListGroupItem, Row } from "react-bootstrap";
import { MdOutlineOilBarrel, MdOutlineSolarPower } from "react-icons/md";
import { SlEnergy } from "react-icons/sl";
import { TbFlame, TbZzz } from "react-icons/tb";
import { BsQuestionLg } from "react-icons/bs";
import { AiOutlineCheck, AiOutlineQuestion } from 'react-icons/ai';
import { HiXMark } from 'react-icons/hi2';
import { useNavigate } from "react-router-dom";

/**
 * Component for displaying Single Elv in a parrent list
 * 
 * @param {props} elv object of elv
 * @param {props} anlage object of anlage
 * 
 * return ListGroupItem
 */
const ElvListItem = ({elv, anlage}) => {

    const navigate = useNavigate();

    const elvDetailHandler = () => {
        navigate(`/hw/dashboard/energieliefervertraege/${elv.id}`);
    }

    return (
        <ListGroupItem onClick={() => elvDetailHandler()} action className="animate__animated animate__zoomIn">
            {anlage !== undefined?
                <Row className="align-items-center">
                    <Col xs="12" md="2" xl="1" className="text-center">
                        {
                            anlage.x_studio_field_3eKe0 === 'Strom' ?
                                <SlEnergy size={30} className={elv.x_is_leerstand? "text-muted":"text-energo"} />
                            :
                            anlage.x_studio_field_3eKe0 === 'Gas' ?
                                <TbFlame size={30} className={elv.x_is_leerstand? "text-muted":"text-cyan"} />
                            :
                            anlage.x_studio_field_3eKe0 === 'Oil' ?
                                <MdOutlineOilBarrel size={30} className={elv.x_is_leerstand? "text-muted":"text-danger"} />
                            :
                            anlage.x_studio_field_3eKe0 === 'Strom-Einspeisung' ?
                                <MdOutlineSolarPower size={30} className={elv.x_is_leerstand? "text-muted":"text-warning"} />
                            :
                                <BsQuestionLg size={30} className="text-muted" />
                        }
                        {
                            elv.x_is_leerstand ?
                                <TbZzz size={20} style={{position: "relative", top: -18, left: -5, transform: "rotate(-20def)"}} />
                            :
                                null
                        }
                    </Col>
                    <Col xs="12" md="10" xl="5">
                        <span className="text-energo">{elv.x_energieprodukt_id[1]}</span> <br />
                        <span>{elv.x_kunde_id[1]}</span> <br />
                        <span>{anlage.x_adresse_kompakt}</span>
                    </Col>
                    <Col xs="12" md="4" xl="3" className="text-center">
                        <p className="text-energo">Vertragszeitraum</p>
                        <p>
                            {elv.x_belbeg !== "" && elv.x_belbeg !== "False" ? new Date(elv.x_belbeg).toLocaleDateString('DE-de') : 'TBA'}
                            &nbsp;-&nbsp;
                            {elv.x_datum_vertragsende !== "" && elv.x_datum_vertragsende !== "False" ? new Date(elv.x_datum_vertragsende).toLocaleDateString('DE-de') : 'offenes Vertragsende'}
                        </p>
                    </Col>
                    <Col xs="6" md="4" xl="2" className="text-center">
                        <p className="text-energo">Anlagenverwendung</p>
                        {
                            anlage.x_anlagenverwendung === "Allgemeine Liegenschaftsteile"? 
                                <p>{anlage.x_anlagenverwendung_detail !== "False"? anlage.x_anlagenverwendung_detail: "Nicht bekannt"}</p>
                            :
                                <p>{anlage.x_bestandseinheitennummer !== "False"? `Top ${anlage.x_bestandseinheitennummer}` : "Nicht bekannt"}</p>
                        }
                    </Col>
                    <Col xs="6" md="4" xl="1" className="text-center">
                        <p className="text-energo">Leerstand</p>
                        {
                            elv.x_is_leerstand ?
                                <p><AiOutlineCheck className="text-energo" /></p>
                            :
                            elv.x_is_leerstand === false ?
                                <p><HiXMark className="text-danger" /></p>
                            :
                                <p><AiOutlineQuestion /></p>
                        }
                    </Col>
                </Row>
            
            :null}
        </ListGroupItem>
    )
}

export default ElvListItem;